import { Injectable, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent } from './confirm-dialog.component';

export interface ConfirmOptions {
  title?: string;
  btnOkText?: string;
  btnCancelText?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  private modalService = inject(NgbModal);

  async confirm(
    message: string,
    options?: ConfirmOptions
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmDialogComponent, { centered: true, size: 'lg' });

    // Inputs übergeben
    modalRef.componentInstance.message = message;
    if (options?.title) modalRef.componentInstance.title = options.title;
    if (options?.btnOkText) modalRef.componentInstance.btnOkText = options.btnOkText;
    if (options?.btnCancelText) modalRef.componentInstance.btnCancelText = options.btnCancelText;

    try {
      const result = await modalRef.result;
      return result === true;
    } catch {
      // Wird ausgelöst, wenn der User außerhalb klickt oder ESC drückt
      return false;
    }
  }
}
